import React from 'react';
import { ThemeProvider as ThemeProvider$1 } from 'styled-components';

const ThemeProvider = ({ children, theme }) => (React.createElement(ThemeProvider$1, { theme: theme }, children));

export { ThemeProvider as default };
//# sourceMappingURL=ThemeProvider.mjs.map
